export function buildQueryPath(params, disableEncodedOutput) {
    if (!params) {
        return '';
    }
    var query = '';
    for (var key in params) {
        var querySeparator = query ? '&' : '';
        var value = void 0;
        if (disableEncodedOutput) {
            value = params[key] ? "".concat(params[key]) : '';
        }
        else {
            value = params[key] ? "".concat(encodeURIComponent(params[key])) : '';
        }
        query = "".concat(query).concat(querySeparator).concat(key, "=").concat(value);
    }
    return query;
}
//# sourceMappingURL=buildQueryPath.js.map